import Header from "../Header/Header";
import { Helmet } from "react-helmet";
import { useSearchParams } from "react-router-dom";
import "../Snack/Snack.css";

const Auth = () => {
  const [searchParams] = useSearchParams();
  const qs = searchParams.toString();
  const suffix = qs ? `?${qs}` : "";
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);

  return (
    <>
      <Helmet>
        <title>Email Confirmed</title>
      </Helmet>
      <div className="App">
        <Header showHome={true} />
        <h2>Email Confirmed ✓</h2>
        <div className="snack-card">
          <h2>You're all set!</h2>
          <p>Go back to the app on your device to log in.</p>
          {isIOS && (
            <div style={{ textAlign: "center", marginTop: "1rem" }}>
              <a
                href={`goodthing://auth${suffix}`}
                style={{
                  display: "inline-block",
                  padding: "0.6rem 1.2rem",
                  background: "black",
                  color: "white",
                  borderRadius: "8px",
                  textDecoration: "none",
                }}
              >
                Open App
              </a>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default Auth;
